import { Icon } from "@iconify/react/dist/iconify.js";
import { Button, SubmitButton } from "../../components";
import FormWrapper from "../forms/Form";
import ModalWrapper from "./Modal";
import styles from "./Modal.module.css";

function DeleteModal({ isVisible, handleClose, handleDelete, message, disableDelete = false }) {
  const handleDeleteAction = (e) => {
    e.preventDefault();
    if (handleDelete) {
      return handleDelete();
    }
  };
  return (
    <ModalWrapper name="rejection_reason_modal" isVisible={isVisible} onClose={handleClose} level={1} fit>
      <FormWrapper id="delete_form" onSubmit={handleDeleteAction}>
        <div className="column">
          <Icon icon="heroicons:exclaimation-triangle" className={styles.error_icon} />
          <div className={styles.error_message}>{message}</div>
          <div className="row center">
            <Button className="cancel" onClick={handleClose}>
              Cancel
            </Button>
            <SubmitButton className="ghost_delete" disabled={disableDelete}>
              Delete
            </SubmitButton>
          </div>
        </div>
      </FormWrapper>
    </ModalWrapper>
  );
}

export default DeleteModal;
